<template>
  <div class="addJobs">
    <van-nav-bar title="实习项目" left-arrow @click-left="$router.go(-1)" z-index="99999" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="add_title">实习信息</div>
    <van-form>
      <van-field :value="form.qymc" label="实习单位" v-if="schoolCode == '10422'" clickable readonly is-link input-align="right" placeholder="请选择" @click="showSxdw = true" />
      <van-field :value="form.qymc" label="实习单位" v-else required clickable readonly is-link :rules="[{ required: true, message: '请选择实习单位' }]" input-align="right" placeholder="请选择" @click="showSxdw = true" />
      <van-popup v-model="showSxdw" position="bottom">
        <van-picker value-key="text" show-toolbar :columns="sxdwList" @confirm="sxdwConfirm" @cancel="showSxdw = false" />
      </van-popup>

      <van-field v-if="schoolCode != '10422'" :value="form.bmks" label="部门/科室" required clickable readonly is-link :rules="[{ required: true, message: '请选择部门/科室' }]" input-align="right" placeholder="请选择" @click="showBm = true" />
      <van-popup v-model="showBm" position="bottom">
        <van-picker value-key="text" show-toolbar :columns="bmList" @confirm="bmConfirm" @cancel="showBm = false" />
      </van-popup>

      <van-field v-if="schoolCode != '10422'" :value="form.gwmc" label="实习岗位" required clickable readonly is-link :rules="[{ required: true, message: '请选择实习岗位' }]" input-align="right" placeholder="请选择" @click="showSxgw = true" />
      <van-popup v-model="showSxgw" position="bottom">
        <van-picker value-key="text" show-toolbar :columns="sxgwList" @confirm="sxgwConfirm" @cancel="showSxgw = false" />
      </van-popup>

      <div class="add_title">项目信息</div>

      <van-field v-model="form.xmkssj" readonly clickable label="开始时间" is-link placeholder="请选择" input-align="right" required @click="showKssj = true" />
      <van-popup v-model="showKssj" position="bottom">
        <van-datetime-picker v-model="currentDate" type="date" title="请选择" :formatter="timeFormatter" @confirm="kssjConfirm" @cancel="showKssj = false" />
      </van-popup>

      <van-field readonly clickable :value="form.xmjssj" label="结束时间" is-link required :label-width="100" placeholder="请选择" input-align="right" @click="showJssj = true" />
      <van-popup v-model="showJssj" position="bottom">
        <van-datetime-picker v-model="currentDate" type="date" title="请选择" :formatter="timeFormatter" @confirm="jssjConfirm" @cancel="showJssj = false" />
      </van-popup>

      <van-field v-model="form.djjs" label="带队教师" required placeholder="请输入" input-align="right" />
      <van-field v-model="form.lxfs" label="教师联系方式" label-width="100" required placeholder="请输入" input-align="right" />
      <van-field v-model="form.xmmc" label="项目名称" required placeholder="请输入" input-align="right" />
      <van-field placeholder="请输入" class="fieldTextarea" v-model="form.xmms" rows="4" autosize label="项目描述" type="textarea" />
      <van-field placeholder="请输入" class="fieldTextarea" v-model="form.zwpj" rows="4" autosize label="自我评价" type="textarea" />
      <div class="footer_btn">
        <van-button class="btn_submit" type="primary" @click="handleSubmit('5')">暂存</van-button>
        <van-button class="btn_submit" type="primary" @click="handleSubmit('2')">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import iApi from '@/utils/internship'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      schoolCode:'',
      form: {
        qymc: '',
        bmks: '',
        gwmc: '',
        xmkssj: '',
        xmjssj: '',
        djjs: '',
        lxfs: '',
        xmmc: '',
        xmms: '',
        zwpj: '',
      },
      currentDate: new Date(),
      sxdwList: [],
      bmList: [],
      sxgwList: [],
      showSxdw: false,
      showBm: false,
      showSxgw: false,
      showKssj: false,
      showJssj: false,
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
      isty: 'getIsty',
      timeRange: 'getTimeRange',
    }),
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.getList()
  },
  methods: {
    async getList() {
      console.log(this.$route.query)
      if (this.$route.query.isEdit) {
        const temp = await iApi.getReSxxmDetail({
          sxxmid: this.$route.query.sxxmid,
          sxfs: this.isty,
        })
        console.log(temp)
        this.form = temp.data
        this.form.sxxmid = this.$route.query.sxxmid
      } else {
        this.sxdwList = []
        this.bmList = []
        this.sxgwList = []
        const obj = {
          sxfs: this.isty,
          sxjhid: this.sxjhid,
        }
        const res = await iApi.getSxxm(obj)
        this.sxdwList.push(res.data[0].qymc)
        this.bmList.push(res.data[0].bmks)
        this.sxgwList.push(res.data[0].gwmc)
        // 查看本地是否有缓存
        const form = localStorage.getItem(this.sxjhid)
        if(form){
          this.form = JSON.parse(form)
          localStorage.removeItem(this.sxjhid)
        }
        // if (this.$route.query.iswfmes === '5') {
        //   const data = {
        //     xmmc: this.form.xmmc,
        //     xmkssj: this.form.xmkssj,
        //     xmjssj: this.form.xmjssj,
        //     djjs: this.form.djjs,
        //     lxfs: this.form.lxfs,
        //     xmms: this.form.xmms,
        //     zwpj: this.form.zwpj,
        //     iswfmes: this.$route.query.iswfmes,
        //   }
        //   const r = await iApi.addSxxm({ sxfs: this.isty, sxjhid: this.sxjhid }, data)
        //   this.form = r.data
        // }
      }
    },
    sxdwConfirm(val) {
      this.form.qymc = val
      this.showSxdw = false
    },
    bmConfirm(val) {
      this.form.bmks = val
      this.showBm = false
    },
    sxgwConfirm(val) {
      this.form.gwmc = val
      this.showSxgw = false
    },
    kssjConfirm(val) {
      if (this.form.xmjssj != '') {
        if (new Date(val).getTime() > new Date(this.form.xmjssj)) {
          this.$toast('开始时间不能大于结束时间')
          return
        }
      }
      this.form.xmkssj = this.getTiem(val)
      this.showKssj = false
    },
    jssjConfirm(val) {
      if (this.form.xmkssj != '') {
        if (new Date(val).getTime() < new Date(this.form.xmkssj)) {
          this.$toast('结束时间不能小于开始时间')
          return
        }
      }
      this.form.xmjssj = this.getTiem(val)
      this.showJssj = false
    },
    timeFormatter(type, val) {
      if (type === 'year') {
        return val + '年'
      }
      if (type === 'month') {
        return val + '月'
      }
      if (type === 'day') {
        return val + '日'
      }
      return val
    },
    getTiem(val) {
      const date = new Date(val)
      const y = date.getFullYear()
      const m = date.getMonth() + 1 > 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
      const d = date.getDate() > 10 ? date.getDate() : '0' + date.getDate()
      return y + '-' + m + '-' + d
    },
    async handleSubmit(zt) {
      const data = {
        xmmc: this.form.xmmc,
        xmkssj: this.form.xmkssj,
        xmjssj: this.form.xmjssj,
        djjs: this.form.djjs,
        lxfs: this.form.lxfs,
        xmms: this.form.xmms,
        zwpj: this.form.zwpj,
        iswfmes: zt,
      }
      // 提交
      if (zt === '2') {
        if(this.schoolCode == '10422'){
          if ( !this.form.xmkssj || !this.form.xmjssj || !this.form.djjs || !this.form.lxfs || !this.form.xmmc) {
            Toast.fail('请填写完整!')
            return false
          }
        }else{
          if (!this.form.qymc || !this.form.bmks || !this.form.gwmc || !this.form.xmkssj || !this.form.xmjssj || !this.form.djjs || !this.form.lxfs || !this.form.xmmc) {
            Toast.fail('请填写完整!')
            return false
          }
        }
        
        const phone = /^1(3|4|5|7|8)\d{9}$/
        if (!phone.test(this.form.lxfs)) {
          Toast.fail('联系方式格式错误!')
          return false
        }
        const res = await iApi.addSxxm({ sxfs: this.isty, sxjhid: this.sxjhid }, data)
        if (res.code === '1') {
          Toast.fail('添加成功!')
          this.$router.go(-2)
        } else {
          Toast.fail('添加失败!')
        }
      } else if (zt === '5') {
        // 本地暂存
        const form = JSON.stringify(this.form)
        localStorage.setItem(this.sxjhid, form)
        // if (res.code === '1') {
        //   Toast.fail(res.Msg)
        //   this.$router.go(-1)
        // } else {
        //   Toast.fail('res.Msg')
        // }
      }
    },
    onClickLeft() {
      if (this.$route.query.isEdit) {
        localStorage.removeItem('edit')
      } else {
        this.handleSubmit('5')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.addJobs {
  margin-top: -50px;
  padding-bottom: 90px;
  background: #f2f2f4;
  .add_title {
    padding: 14px 0 6px 15px;
    box-sizing: border-box;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .fieldTextarea {
    flex-direction: column;
  }
  .footer_btn {
    width: 100%;
    height: 70px;
    position: fixed;
    bottom: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
    box-sizing: border-box;
    .btn_submit {
      padding: 12px 65px;
      box-sizing: border-box;
      border-radius: 25px !important;
      background: #0189f9;
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
      border: 1px solid #e5e5e5;
      white-space: nowrap;
    }
    .btn_submit:first-child {
      background: #fff;
      color: #666666;
      margin-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/addJobs.vue